import type { MouseEventHandler } from 'react';

import get from 'lodash/get';

import { cssModules } from '@skyscanner/backpack-web/bpk-react-utils';

import MapPriceMarkerButton from '../MapPriceMarkerButton';

import type { Status } from '../MapPriceMarkerButton/MapPriceMarkerButton';
import type { Configs } from '@shared/types/configs';
import type { HotelCard } from '@shared/types/frontend/hotel-card';
import type { Nullable } from '@shared/types/utils';

import STYLES from './MapMarkerTarget.module.scss';

import { withConfiguration } from '@shared/utils-frontend/contexts/ConfigurationContext';
import { MAX_PRICE_MARKER_COUNT } from '@shared/utils-frontend/markers';

const cls = cssModules(STYLES);

type Props = {
  configs: Configs;
  priceText: Nullable<string>;
  id?: string;
  hotelCard: HotelCard;
  onClick?: MouseEventHandler;
  mapRefreshStatus: Status;
  selected?: boolean;
  hotelCardPosition: number;
};

const MapMarkerTarget = (props: Props) => {
  const {
    configs: { expandPageSizeEnabled },
    hotelCard,
    hotelCardPosition,
    id,
    mapRefreshStatus,
    onClick,
    priceText,
    selected,
  } = props;

  const loading = get(hotelCard, 'priceInfo.loading');

  if (loading || !priceText) {
    return (
      <div className={cls('MapMarkerTarget__clusterContainer--cluster')} />
    );
  }

  if (
    !expandPageSizeEnabled &&
    hotelCardPosition > MAX_PRICE_MARKER_COUNT &&
    !selected
  ) {
    return (
      <div className={cls('MapMarkerTarget__clusterContainer')}>
        <div
          className={cls(
            'MapMarkerTarget__clusterContainer--cluster',
            'MapMarkerTarget__clusterContainer--initial',
          )}
        />
        <div className={cls('MapMarkerTarget__clusterContainer--replacement')}>
          <MapPriceMarkerButton
            key={id}
            label={priceText}
            accessibilityLabel={priceText}
            status={mapRefreshStatus}
            onClick={onClick}
          />
        </div>
      </div>
    );
  }

  return (
    <MapPriceMarkerButton
      key={id}
      label={priceText}
      accessibilityLabel={priceText}
      status={mapRefreshStatus}
      onClick={onClick}
    />
  );
};

export default withConfiguration(MapMarkerTarget);
